import { render } from "./CreateExamBlanc.vue?vue&type=template&id=5193d64b&scoped=true"
import script from "./CreateExamBlanc.vue?vue&type=script&lang=js"
export * from "./CreateExamBlanc.vue?vue&type=script&lang=js"

import "./CreateExamBlanc.vue?vue&type=style&index=0&id=5193d64b&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5193d64b"]])

export default __exports__